class ListQuotes{
    constructor(el) {
        this.scope = el;
        this.items = el.querySelector('[data-items]');
        this.prevButton = el.querySelector('[data-prev]');
        this.nextButton = el.querySelector('[data-next]');
        if(
            (this.items.children.length > 2) ||
            (this.items.children.length === 2 && viewport() === 0)
        ){
            this.slider = new Slider(this.scope, this.items, [this.prevButton, this.nextButton],[2,2,3]);
        }else{
            this.scope.classList.add("list-blockquotes--static");
            this.scope.classList.toggle("list-blockquotes--single", this.items.children.length === 1)
        }
    }
}

ControlBinders.register(`[data-list-quotes]`, el => new ListQuotes(el));